import { useSiteStore } from '@centric-os/stores/sites/use-site-store';
import type { SiteLocation } from '@centric-os/types';
import { cloneDeep } from 'lodash-es';
import { storeToRefs } from 'pinia';

export default () => {
  const mapBusinessUnitPayload = (formValues: Partial<SiteLocation>): Partial<SiteLocation> => {
    // Set site store
    const siteStore = useSiteStore();
    const { site } = storeToRefs(siteStore);

    const businessUnitPayload = cloneDeep(formValues);
    businessUnitPayload.address = { ...site.value.address };
    businessUnitPayload.brands = [];
    businessUnitPayload.label = { en: businessUnitPayload.name };
    businessUnitPayload.latitude = site.value.address.coordinates.latitude;
    businessUnitPayload.longitude = site.value.address.coordinates.longitude;
    businessUnitPayload.meta.unit_id = Number(businessUnitPayload.meta.unit);
    businessUnitPayload.meta.unit = Number(businessUnitPayload.meta.unit);
    businessUnitPayload.meta.jde_environment = businessUnitPayload.meta.jde_environment ?? null;
    return businessUnitPayload;
  };
  return { mapBusinessUnitPayload };
};
